export const enum Privilege {
  BUILD = 'BUILD',
  INTEGRATION_PACK = 'INTEGRATION_PACK',
  PROCESS_LIBRARY = 'PROCESS_LIBRARY',
  ACCT_GRP_MGMT = 'ACCT_GRP_MGMT',
  ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
}
class PrivilegeManager {
  private privilege: Set<string> | null = null;

  private checkAccountPrivilege(privilege: Privilege): boolean {
    return this.privilege?.has(privilege) ?? false;
  }

  public setAccountPrivileges(accountPrivileges: string[]): void {
    if (accountPrivileges && accountPrivileges.length > 0) {
      this.privilege = new Set(accountPrivileges);
    } else {
      this.privilege = new Set();
    }
  }

  public getAccountPrivileges(): any {
    return this.privilege;
  }

  public hasAccountPrivilege(privilege: Privilege): boolean {
    return this.checkAccountPrivilege(privilege);
  }

  public isAccountAdmin(privilege: Privilege): boolean {
    return this.hasAccountPrivilege(privilege);
  }
}

export default PrivilegeManager;
